/* tslint:disable */
import {
  HttpClient,
  HttpContext,
  HttpHeaders,
  HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import { NotificationPreferencesModel } from '../../models/notification-preferences-model';

export function notificationPreferencesGet(
  http: HttpClient,
  rootUrl: string,
  headers: HttpHeaders,
  context?: HttpContext,
): Observable<StrictHttpResponse<NotificationPreferencesModel>> {
  const rb = new RequestBuilder(
    rootUrl,
    notificationPreferencesGet.PATH,
    'get',
  );

  for (const headerKey of headers.keys()) {
    rb.header(headerKey, headers.get(headerKey));
  }

  return http
    .request(rb.build({ responseType: 'json', accept: '*/*', context }))
    .pipe(
      filter(
        (r: unknown): r is HttpResponse<unknown> => r instanceof HttpResponse,
      ),
      map((r: HttpResponse<unknown>) => {
        return r as StrictHttpResponse<NotificationPreferencesModel>;
      }),
    );
}

notificationPreferencesGet.PATH = '/api/v1/notifications/preferences';
